const { mainServer } = require("../../../variables/config");

export const request_faveproducts = async(params) => {
    const credentials = JSON.parse(localStorage.getItem('token_data'))
    mainServer.defaults.headers.common['Authorization'] = credentials.token
    const response = await mainServer.get(`/favoriteproduct/list${params}` )
    return response.data.data
}


export const request_create_product = async(data) => {
    const credentials = JSON.parse(localStorage.getItem('token_data'))
    mainServer.defaults.headers.common['Authorization'] = credentials.token
    const response = await mainServer.post(`/product`, data)
    return response.data.data
}